module.exports = __webpack_public_path__ + "static/media/日历13@2x.7d43151c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历13@2x.png
// module id = 1386
// module chunks = 0